import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // optional background image

const ManagementSystemsCertificationScheme = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Management Systems Certification Scheme</h1>
          <p className="subtitle">
      MBS helps organizations demonstrate that their management systems are implemented effectively, 
      promoting confidence among clients, stakeholders, and regulatory bodies.
    </p>
        </div>
      </section>

      {/* === Overview Section === */}
      <section className="what-section">
      <p className="subtitle">
            In today's highly competitive global market, customers, employees, stakeholders, governments, 
            and the general public demand that organizations adopt management systems ensuring consistent quality and safety.
          </p>
          <p className="subtitle">
            To assist industries and commerce, MBS launched the Management System Certification Scheme (MSCS) to provide third-party certification for various scopes of management systems.
          </p>
        <p className="paragraph">
          The MBS provides third-party certification services to organizations that need to demonstrate that they have implemented and are maintaining effective management systems in the specified areas. Certification is provided impartially and without discrimination.
        </p>

        <h2 className="section-title">Management Systems Certification Services Offered</h2>
        <ul className="paragraph no-indent">
          <li>Quality Management System according to MS ISO 9001:2015 standard</li>
          <li>Food Safety Management System according to MS ISO 22000:2018 standard</li>
          <li>Certification scopes are being expanded to cover a wider client base</li>
        </ul>

        <h2 className="section-title">Certification Process</h2>

        <h3 className="paragraph">Inquiry</h3>
        <p className="paragraph">
          Prospective clients make inquiries to MBS MSCD via email: <a href="mailto:mbs@mbsmw.org">mbs@mbsmw.org</a>, postal address: P.O. Box 946 Blantyre, phone: +265 891 376 444 /445 /446 /447, or by visiting the office. MBS MSCD responds with the application form if interested.
        </p>

        <h3 className="paragraph">Application Process</h3>
        <p className="paragraph">
          Clients submit the Management Systems Certification Application Form. Upon receipt, MBS MSCD acknowledges the application, reviews it for completeness, and communicates acceptance or rejection.
        </p>

        <h3 className="paragraph">Pre-Audit Processes</h3>
        <ul className="paragraph no-indent">
          <li>Preparation and issuance of certification quotation</li>
          <li>Client accepts quotation</li>
          <li>Signing of certification agreement</li>
          <li>Invoice issuance and payment</li>
          <li>Preparation of certification program</li>
        </ul>

        <h3 className="paragraph">Initial Certification Processes</h3>
        <p className="paragraph">
          Initial certification follows a two-stage process (Stage 1 and Stage 2):
        </p>
        <ul className="paragraph no-indent">
          <li>Stage 1: Review application, evaluate site conditions, and assess preparedness for Stage 2. Areas of concern may be identified but no nonconformities are raised.</li>
          <li>Stage 2: Conducted at the client’s site to evaluate implementation and effectiveness. Non-conformities are recorded and corrective actions are submitted to MBS MSCD for review.</li>
        </ul>

        <h3 className="paragraph">Certification Decision</h3>
        <p className="paragraph">
          The Certification Committee decides on granting, extending, suspending, withdrawing, or reducing certification scope based on the auditor’s recommendation.
        </p>

        <h3 className="paragraph">Surveillance and Recertification</h3>
        <ul className="paragraph no-indent">
          <li>Surveillance audits ensure continued compliance, conducted at least once a year within the certification cycle.</li>
          <li>Recertification involves a full system audit six months before certificate expiry to verify continued conformity and effectiveness.</li>
        </ul>

        <h3 className="paragraph">Suspension, Restoration, and Withdrawal</h3>
        <ul className="paragraph no-indent">
          <li>Suspension occurs due to non-compliance, audit denial, voluntary request, or non-payment of fees.</li>
          <li>Certification may be restored once issues causing suspension are resolved.</li>
          <li>Withdrawal occurs when issues persist, are not resolved in time, or upon voluntary request.</li>
        </ul>

        <h3 className="paragraph">Audit Process</h3>
        <ul className="paragraph no-indent">
          <li>Verify policies, procedures, and records against the management system standard</li>
          <li>Identify opportunities for improvement without providing specific solutions</li>
          <li>Ensure corrective actions are implemented and reviewed by MBS MSCD</li>
        </ul>

        <h3 className="paragraph">Transfer of Certification</h3>
        <ul className="paragraph no-indent">
          <li>Inquiry, application, assessment, and decision by Certification Committee</li>
          <li>Only valid certificates from accredited bodies can be transferred</li>
          <li>Certification programs may be adjusted for smooth transition</li>
        </ul>

        <h3 className="paragraph">Use of MBS Name and Certification Mark</h3>
        <p className="paragraph">
          Certified clients may use the MBS Management System Certification Mark only according to MBS guidelines, including correct company name, certificate number, reference to standard, scope, validity, and approved colors. The mark cannot be used on products or product packaging.
        </p>

        <h3 className="paragraph">Complaints and Appeals Processing</h3>
        <p className="paragraph">
          Complaints or appeals can be submitted via forms to MBS MSCD. Processes include receiving, validating, investigating, tracking, and recording actions, ensuring correction and reporting results to the complainant or appellant.
        </p>

        <h3 className="paragraph">Management of Impartiality</h3>
        <p className="paragraph">
          MBS MSCD ensures certification activities are conducted impartially, objectively, and without conflict of interest. Risks to impartiality are identified, assessed, resolved, and monitored.
        </p>

        <h2 className="section-title">List of MSC Certified Clients</h2>
        <p className="paragraph">
          For more information, contact:
        </p>
        <p className="paragraph">
          Gloria Chaonamwene Mereka<br/>
          Director of Quality Assurance Services Department<br/>
          Malawi Bureau of Standards<br/>
          P.O. Box 946, Blantyre<br/>
          Telephone: +265 1 870 488<br/>
          Mobile: +265 882 004 488<br/>
          Email: <a href="mailto:gchaonamwene@mbsmw.org">gchaonamwene@mbsmw.org</a>
        </p>
      </section>

      <br /><br />

      {/* === Inline Styles === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }
        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }
        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }
        .what-section { padding: 50px 80px; }
        .section-title { font-size: 1.8rem; font-weight: bold; margin-bottom: 20px; text-align: center; }
        .paragraph { font-size: 1rem; line-height: 1.7; margin: 15px 0; text-align: left; }
        ul { margin: 10px 0; padding-left: 0; list-style-position: inside; }
        li { margin-bottom: 10px; }
        a { color: #ff6600; font-weight: bold; text-decoration: none; }
        a:hover { text-decoration: underline; }
        @media screen and (max-width: 768px) {
          .what-section { padding: 25px 20px; }
          .page-title { font-size: 2rem; }
          .overlay { width: 95%; padding: 25px; }
        }
      `}</style>

    </div>
  );
};

export default ManagementSystemsCertificationScheme;
